
import { useState } from "react";
import { numberdata } from "../Data/Aboutus";
import Numbercomponent from "./Numbercomponent";
import TitleContent from "./TitleContent";

export default function Numbers() {
  const [slideicon, setslideicon] = useState(false);
  const slideLeft = () => {
    var slider = document.getElementById("slider");
    slider.scrollLeft = slider.scrollLeft - 350;
  };

  const slideRight = () => {
    var slider = document.getElementById("slider");
    slider.scrollLeft = slider.scrollLeft + 350;
  };

  return (
    <div className="flex flex-col pt-20">
      <div className="flex flex-col items-center justify-center gap-6">
        
        <TitleContent title="We Take Pride in Our Numbers" content="" />
        <div className="sm:w-[100%] w-[90%] flex flex-wrap items-center justify-center sm:gap-5 gap-2 mb-8">
          {numberdata.map((item) => (
            <div key={item.id}>
              <Numbercomponent number={item.number} name={item.name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
